
import RestService from "../services/rest.service"

export const getFiltersList = (code) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/dashboard/filters/${code}?cycle_type=annual`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getEmployeeList = (code, filters) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/employee/${code}/list`, filters).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getAchievementDashboard = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/dashboard/achievement`, data?.reqData).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getEvaluationDashboard = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/dashboard/evaluation?${data?.query}`, data?.reqData).then(
      (response) => {
        let data = response.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getCompetencyGapDashboard = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/dashboard/competency/gap`, data?.reqData).then(
      (response) => {
        let data = response.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getCompetencyRatingDashboard = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/dashboard/competency/rating`, data?.reqData).then(
      (response) => {
        let data = response.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getGoalDashboard = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/dashboard/goal`, data?.reqData).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const postGoalFormStatusEmployeeDashboard = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/dashboard/goal/formstatus/employee`, data).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const postGoalProgressEmployeeDashboard = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/dashboard/goal/progress/employee`, data).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const postGoalProgressLogDashboard = (formId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/dashboard/goal/progress/logs/${formId}`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}